import { FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '@shared/services/utils/utils.service';
import { take } from 'rxjs/operators';
import { ValidationDiscountService } from 'src/app/core/providers/services/validation-discount/validation-discount.service';
import { DURATION_INPUTS, ELEMENTS_TO_VALIDATE, Numbers } from 'src/app/utils/constants';

export default class CalcBudgetStepOneUtilsExtendedComponent {

  /**
   * constructor
   * @param utilsSrv utilsSrv
   */
  constructor(utilsSrv: UtilsService) {
    this.utilsSrv = utilsSrv;
  }
  readonly utilsSrv: UtilsService;
  promotionChange: { name: string, value: any };
  checkPromoS = false;

  /**
   * localStoregaRemoveItems
   * @param itemsToRemove itemsToRemove
   */
  localStoregaRemoveItems(itemsToRemove: string[]): void {
    itemsToRemove.forEach(item => {
      localStorage.removeItem(item);
    });
  }

  /**
   * checkCodePromotional
   * @param code code
   * @param promotionChange promotionChange
   * @param vdSrv vdSrv
   */
  async checkCodePromotional(code: string, promotionChange: any, vdSrv: ValidationDiscountService): Promise<void> {
    const callback: (codeStatus: any) => void = (codeStatus: any) => {
      if (promotionChange === !codeStatus) {
        promotionChange = { name: 'promo', value: 'error' };
      } else {
        promotionChange = {};
      }
    };
    await this.utilsSrv.getCheckValidationCodeSubscribe(vdSrv, code, callback);
  }

  /**
   * setInputValidator
   * @param inputs inputs
   * @param formData formData
   * @param insureSelected insureSelected
   */
  setInputValidator(inputs: string[], formData: FormGroup, insureSelected: string): void {
    inputs.forEach(element => {
      formData.get([insureSelected, `${element}`]).setValidators([Validators.required]);
    });
  }

  /**
   * setValidator
   * @param formData formData
   * @param insureSelected insureSelected
   */
  public setValidator(formData: FormGroup, insureSelected: string): void {
    const elementsName: string[] = ELEMENTS_TO_VALIDATE;
    if (insureSelected === 'sportTravelAsistance') { elementsName.push('sports'); }

    this.setInputValidator(elementsName, formData, insureSelected);
    this.updateInputs(elementsName, formData, insureSelected);
  }

  /**
   * setTravelersTypeArgs
   * @param formDataValue formDataValue
   * @param typeT typeT
   * @param numberOfInsureds numberOfInsureds
   * @param numberOfInsuredsOlder numberOfInsuredsOlder
   * @param numberOfInsuredsRisk numberOfInsuredsRisk
   * @returns returns
   */
  setTravelersTypeArgs(formDataValue: any, typeT: string, numberOfInsureds: any, numberOfInsuredsOlder: any, numberOfInsuredsRisk: any): {
    formDataValue: any;
    auxDestiny: any;
    auxExpatriado: boolean;
    auxDays: number;
    numViajerosNormales: number;
    numberOfInsuredsRisk: any;
    numberOfInsuredsOlder: any;
  } {
    const needGetValue: boolean = DURATION_INPUTS.some(value => {
      return formDataValue.insuranceDuration === value;
    });
    let insuranceDuration: string = formDataValue.insuranceDuration;
    if (needGetValue) {
      insuranceDuration = this.utilsSrv.getTranslate(formDataValue.insuranceDuration);
    }

    let isTypeTravel = false;
    if (typeT === '90') {
      isTypeTravel = true;
    }

    let isTypeAnual = false;
    if (typeT === 'anual') {
      isTypeAnual = true;
    }
    const isExpatriado: boolean = this.isExpatriado(isTypeAnual, insuranceDuration);
    const numViajerosNormales = numberOfInsureds.id - (numberOfInsuredsOlder + numberOfInsuredsRisk);
    const auxDays: number = this.insuranceTravelers(typeT, formDataValue);

    let auxExpatriado: boolean = isExpatriado;
    if (isTypeTravel) {
      auxExpatriado = true;
    }

    const auxDestiny: any = formDataValue.countryDestinyEnvironment;

    return {
      formDataValue, auxDestiny, auxExpatriado, auxDays, numViajerosNormales,
      numberOfInsuredsRisk, numberOfInsuredsOlder
    };
  }

  /**
   * updateInputs
   * @param inputs inputs
   * @param formData formData
   * @param insureSelected insureSelected
   */
  updateInputs(inputs: string[], formData: FormGroup, insureSelected: string): void {
    inputs.forEach(element => {
      formData.get([insureSelected, `${element}`]).updateValueAndValidity();
    });
  }

  /**
   * insuranceTravelers
   * @param typeT typeT
   * @param formDataValue formDataValue
   * @returns returns
   */
  insuranceTravelers(typeT: string, formDataValue: any): number {
    let auxDays: number = formDataValue.insuranceTime;
    if ((typeT === 'anual' || typeT === '90') && formDataValue.insuranceTime < Numbers.number365) {
      auxDays = Numbers.number365;
    }
    return auxDays;
  }

  /**
   * isExpatriado
   * @param isTypeAnual isTypeAnual
   * @param insuranceDuration insuranceDuration
   * @returns returns
   */
  isExpatriado(isTypeAnual: boolean, insuranceDuration: string): boolean {
    let isExpatriado: boolean;
    if (isTypeAnual) {
      isExpatriado = false;
    } else {
      isExpatriado = (insuranceDuration === 'Larga Estancia' || insuranceDuration === 'Larga estancia');
    }
    return isExpatriado;
  }

  /**
   * prepareConditions
   * @param formData formData
   * @param insureSelected insureSelected
   * @returns returns
   */
  prepareConditions(formData: FormGroup, insureSelected: string): {
    guarantee: number;
    insuredsPlayRisk: number;
  } {
    const guarateeLimit: any = formData.get([insureSelected, 'guaranteeLimitOfMedicalExpenses']).value.name;
    const insuredsPlayRiskSports: any = formData.get([insureSelected, 'insuredsPlayRiskSports']).value.name;
    const guarantee = parseInt(guarateeLimit, Numbers.number10);
    const insuredsPlayRisk = parseInt(insuredsPlayRiskSports, Numbers.number10);
    return { guarantee, insuredsPlayRisk };
  }

  /**
   * checkInsuredSelected
   * @param formData formData
   * @param insureSelected insureSelected
   * @returns returns
   */
  checkInsuredSelected(formData: FormGroup, insureSelected: string): boolean {
    this.prepareConditions(formData, insureSelected);
    const { guarantee }: { guarantee: number } = this.prepareConditions(formData, insureSelected);
    return (guarantee === Numbers.number12000 && insureSelected === 'individualTravelAsistance' && formData.get([insureSelected, 'petInsureds']).value === '' );
  }

  /**
   * checkGuarantieAndInsuredPlayRisk
   * @param formData formData
   * @param insureSelected insureSelected
   * @returns returns
   */
  checkGuarantieAndInsuredPlayRisk(formData: FormGroup, insureSelected: string): boolean {
    const { guarantee, insuredsPlayRisk }: {
      guarantee: number;
      insuredsPlayRisk: number;
    } = this.prepareConditions(formData, insureSelected);
    return (guarantee === Numbers.number18000 && (insuredsPlayRisk === 0 || Number.isNaN(insuredsPlayRisk) || formData.get([insureSelected, 'petInsureds']).value === ''));
  }

  /**
   * noShowGuaranteeTable
   * @param formData formData
   * @param insureSelected insureSelected
   * @returns returns
   */
  noShowGuaranteeTable(formData: FormGroup, insureSelected: string): boolean {
    return this.checkGuarantieAndInsuredPlayRisk(formData, insureSelected) ||
      this.checkInsuredSelected(formData, insureSelected);
  }

  /**
   * resetTable
   * @param formData formData
   * @param insureSelected insureSelected
   * @returns returns
   */
  resetTable(formData: FormGroup, insureSelected: string): boolean {
    let showGuaranteeTable = true;
    if (this.noShowGuaranteeTable(formData, insureSelected)) {
      showGuaranteeTable = false;
    }
    return showGuaranteeTable;
  }

  /**
   * checkShowGuaranteeTable
   * @param formData formData
   * @param insureSelected insureSelected
   * @returns returns
   */
  checkShowGuaranteeTable(formData: FormGroup, insureSelected: string): boolean {
    return this.checkGuarantieAndInsuredPlayRisk(formData, insureSelected);
  }

  /**
   * checkCodePromotional2
   * @param code code
   */
  checkCodePromotional2(code: string, vdSrv: ValidationDiscountService): void {
    vdSrv.getCheckValidationCode(code).pipe(take(1)).subscribe((codeStatus: any) => {
      if (!codeStatus) {
        this.promotionChange = { name: 'promo', value: 'error' };
      }
      this.checkPromoS = codeStatus;
    });
    setTimeout(() => {
      return this.checkPromoS;
    }, Numbers.number200);
  }

  /**
   * @description funcion para comprobar las personas que realizan deporte de riesgo y son mayores de 70
   * @param formDataValue datos del formulario
   * @param formData formulario con los controles
   * @param insureSelected tipo de formulario
   * @returns suma de los mayores y deportistas de riesgo
   */
  olderAndRiskSportPeople(formDataValue: any, formData: FormGroup, insureSelected: string): number {
    let more70 = 0;
    let riskSport = 0;
    if (formDataValue.insuredOlderThan70years) {
      more70 = formDataValue.insuredOlderThan70years.id;
    }
    if ( formDataValue.insuredsPlayRiskSports) {
      riskSport = formDataValue.insuredsPlayRiskSports.id;
    }

    if (more70 + riskSport > formDataValue.numberOfInsured.id) {
      formData.get([insureSelected, 'insuredsPlayRiskSports']).setErrors({ required: true });
    } else {
      formData.get([insureSelected, 'insuredsPlayRiskSports']).setErrors(null);
    }

    return more70 + riskSport;
  }
}
